import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

declare const Office: {
    AsyncResultStatus: {
        Succeeded: string;
    };
    CoercionType: {
        Html: string;
        Text: string;
    };
    onReady: (callback: (info: { host: string; platform: string }) => void) => void;
    context: OfficeContext;
};

interface OfficeItem {
    subject: string;
    internetMessageId: string;
    from: {
        emailAddress: string;
    };
    to: Array<{ emailAddress: string }>;
    cc: Array<{ emailAddress: string }>;
    bcc: Array<{ emailAddress: string }>;
    attachments: Array<any>;
    dateTimeCreated: string | Date;
    body: {
        getAsync: (coercionType: any, options: any, callback: (result: any) => void) => void;
    };
    getAttachmentContentAsync: (attachmentId: string, options: any, callback: (result: any) => void) => void;
}

interface OfficeMailbox {
    item?: OfficeItem;
}

interface OfficeContext {
    mailbox?: OfficeMailbox;
}

@Injectable({
    providedIn: 'root'
})
export class OfficeService {
    private isOfficeInitialized = new BehaviorSubject<boolean>(false);
    private isOfficeContext = false;

    constructor() {
        // Wait for Office to be available
        const checkOffice = setInterval(() => {
            if (typeof Office !== 'undefined') {
                clearInterval(checkOffice);
                
                // Initialize Office and wait for onReady callback
                Office.onReady((info) => {
                    console.log('Office.js is ready in service');
                    console.log('- Host:', info.host);
                    console.log('- Platform:', info.platform);
                    this.isOfficeContext = true;
                    this.isOfficeInitialized.next(true);
                });
            }
        }, 100);

        // Timeout after 5 seconds
        setTimeout(() => {
            clearInterval(checkOffice);
            if (!this.isOfficeInitialized.value) {
                console.warn('Office.js did not initialize in time');
                this.isOfficeInitialized.next(false);
            }
        }, 5000);
    }

    get isInitialized() {
        return this.isOfficeInitialized.asObservable();
    }

    get inOfficeContext() {
        return this.isOfficeContext;
    }

    getOfficeContext(): OfficeContext | null {
        if (!this.isOfficeContext || typeof Office === 'undefined') {
            return null;
        }
        return Office.context;
    }

    getMailbox(): OfficeMailbox | null {
        const context = this.getOfficeContext();
        return context?.mailbox || null;
    }

    getItem(): OfficeItem | null {
        const mailbox = this.getMailbox();
        return mailbox?.item || null;
    }
}
